import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./TableUserItem.module.scss";
import cn from "classnames";
export const TableUserItem = (props) => {
    const { name, slot, isLast } = props;
    return (_jsxs("tr", Object.assign({ className: cn(styles.wrapper, isLast && styles.last) }, { children: [_jsx("td", { children: name }), _jsx("td", { children: slot && _jsx(_Fragment, { children: slot }) })] })));
};
